import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { XMarkIcon } from '@heroicons/react/24/outline';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeTag, setActiveTag] = useState('All');

  const images = [
    // Field Trips
    { src: '/assets/images/gallery/Field Trips/103C3218-6251-4839-A3AD-C80DB45B2CEC (1).jpg', alt: 'Students on a school field trip', tag: 'Field Trips' },
    { src: '/assets/images/gallery/Field Trips/5CD438A6-34E9-44F7-A854-CB96193BBA2B (1).jpg', alt: 'Students exploring on a field trip', tag: 'Field Trips' },
    { src: '/assets/images/gallery/Field Trips/BridgeTrip2025-02.jpg', alt: 'Students visiting a bridge on a class trip', tag: 'Field Trips' },
    { src: '/assets/images/gallery/Field Trips/BridgeTrip2025-39.jpg', alt: 'Class group photo during bridge trip', tag: 'Field Trips' },
    { src: '/assets/images/gallery/Field Trips/C17C6A4C-99F0-4895-983D-14DABEFAA933 (1).jpg', alt: 'Students during a field trip outing', tag: 'Field Trips' },
    { src: '/assets/images/gallery/Field Trips/F75A36C9-E3E2-4BE9-B91F-234828A42A4D (1).jpg', alt: 'Students enjoying a field trip activity', tag: 'Field Trips' },
    { src: '/assets/images/gallery/Field Trips/Hampton MOMA 3.jpg', alt: 'Students at the Museum of Modern Art', tag: 'Field Trips' },
    { src: '/assets/images/gallery/Field Trips/Hampton trip to Moma 2.jpg', alt: 'Class trip to the Museum of Modern Art', tag: 'Field Trips' },
    { src: '/assets/images/gallery/Field Trips/Hampton trip to MOMA.jpg', alt: 'Students exploring the Museum of Modern Art', tag: 'Field Trips' },
    // Halloween
    { src: '/assets/images/gallery/Halloween/20251031_120012 (1).jpg', alt: 'Students in Halloween costumes at school', tag: 'Halloween' },
    { src: '/assets/images/gallery/Halloween/4DF6F7E3-19B0-45EC-8FAC-F6BC7A0507C5 (1).jpg', alt: 'Halloween celebration at school', tag: 'Halloween' },
    { src: '/assets/images/gallery/Halloween/FallBall2025_SKP-002.jpg', alt: 'Students at the Fall Ball 2025 dance', tag: 'Halloween' },
    { src: '/assets/images/gallery/Halloween/FallBall2025_SKP-003.jpg', alt: 'Fall Ball 2025 celebration', tag: 'Halloween' },
    { src: '/assets/images/gallery/Halloween/FallBall2025_SKP-051.jpg', alt: 'Students dancing at Fall Ball 2025', tag: 'Halloween' },
    { src: '/assets/images/gallery/Halloween/FallBall2025_SKP-086.jpg', alt: 'Fall Ball 2025 event', tag: 'Halloween' },
    { src: '/assets/images/gallery/Halloween/IMG_7269_(1).jpg', alt: 'Halloween costume parade at school', tag: 'Halloween' },
    { src: '/assets/images/gallery/Halloween/IMG_7273_(1).jpg', alt: 'Students dressed up for Halloween', tag: 'Halloween' },
    { src: '/assets/images/gallery/Halloween/IMG_7279_(1).jpg', alt: 'Halloween festivities at PSMS 108', tag: 'Halloween' },
    { src: '/assets/images/gallery/Halloween/IMG_7281_(1).jpg', alt: 'Students celebrating Halloween at school', tag: 'Halloween' },
    // Knicks
    { src: '/assets/images/gallery/Knicks/KnicksStem2025_SKP (139 of 386).jpg', alt: 'Students at Knicks STEM Day 2025', tag: 'Knicks' },
    { src: '/assets/images/gallery/Knicks/KnicksStem2025_SKP (149 of 386).jpg', alt: 'Knicks STEM activity with students', tag: 'Knicks' },
    { src: '/assets/images/gallery/Knicks/KnicksStem2025_SKP (186 of 386).jpg', alt: 'Students participating in Knicks STEM workshop', tag: 'Knicks' },
    { src: '/assets/images/gallery/Knicks/KnicksStem2025_SKP (212 of 386).jpg', alt: 'Knicks STEM Day hands-on learning', tag: 'Knicks' },
    { src: '/assets/images/gallery/Knicks/KnicksStem2025_SKP (250 of 386).jpg', alt: 'Students engaged in Knicks STEM activities', tag: 'Knicks' },
    { src: '/assets/images/gallery/Knicks/KnicksStem2025_SKP (262 of 386).jpg', alt: 'Knicks STEM Day team activity', tag: 'Knicks' },
    { src: '/assets/images/gallery/Knicks/KnicksStem2025_SKP (283 of 386).jpg', alt: 'Students collaborating at Knicks STEM event', tag: 'Knicks' },
    { src: '/assets/images/gallery/Knicks/KnicksStem2025_SKP (365 of 386).jpg', alt: 'Knicks STEM Day celebration', tag: 'Knicks' },
    { src: '/assets/images/gallery/Knicks/KnicksStem2025_SKP (41 of 386).jpg', alt: 'Students at Knicks STEM program', tag: 'Knicks' },
    { src: '/assets/images/gallery/Knicks/KnicksStem2025_SKP (9 of 386).jpg', alt: 'Knicks STEM Day opening activities', tag: 'Knicks' },
    // Additional
    { src: '/assets/images/gallery/Additional/IMG_0003.jpg', alt: 'Students at PSMS 108', tag: 'Additional' },
    { src: '/assets/images/gallery/Additional/IMG_0008.jpg', alt: 'Students at PSMS 108', tag: 'Additional' },
    { src: '/assets/images/gallery/Additional/IMG_8348.jpg', alt: 'Students at PSMS 108', tag: 'Additional' },
    { src: '/assets/images/gallery/Additional/IMG_8349.jpg', alt: 'Students at PSMS 108', tag: 'Additional' },
    { src: '/assets/images/homepage/testing_2.jpeg', alt: 'PSMS 108 school event', tag: 'Additional' },
    { src: '/assets/images/homepage/testing1.jpeg', alt: 'PSMS 108 school event', tag: 'Additional' },
    { src: '/assets/images/homepage/testing3.jpeg', alt: 'PSMS 108 school event', tag: 'Additional' },
    { src: '/assets/images/homepage/testing4.jpeg', alt: 'PSMS 108 school event', tag: 'Additional' },
    { src: '/assets/images/homepage/testing5.jpeg', alt: 'PSMS 108 school event', tag: 'Additional' },
    // Wellness
    { src: '/assets/images/gallery/Wellness/020EF412-8733-485C-B807-FC376F2E7757.jpg', alt: 'Students at a wellness program event', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/0376621F-820F-45DC-BC5B-308715F94B5F.jpg', alt: 'Wellness activity at PSMS 108', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/1A278919-3728-4806-A8F7-57A96AC945D9.jpg', alt: 'Students participating in wellness program', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/2B0D712D-43B5-4839-85CC-ABD33498A544.jpg', alt: 'Wellness event at school', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/40F09D9E-EB63-485B-AC15-31C8C8C8F166.jpg', alt: 'Healthy eating program at school', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/4DB5E773-09DD-48D3-9037-9A28C28E9E1D.jpg', alt: 'Students during wellness class', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/55138462-06D4-45E0-9F5F-E9F08FD4D3EF.jpg', alt: 'Wellness program group activity', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/6520E8F1-618D-4DD6-8200-89811B1B88BB.jpg', alt: 'Students at wellness event', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/902BB453-08B6-4FA3-8A26-26CA2CC29936.jpg', alt: 'Wellness program at PSMS 108', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/A3E4CE65-7F1E-4F3D-85B8-7251C1E4505C (1).jpg', alt: 'Students in wellness program session', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/DFA28E50-6A20-4BB5-AA8F-725B14719D00.jpg', alt: 'Wellness awareness event at school', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/IMG_0675_(1).jpg', alt: 'Students preparing healthy food', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/IMG_0676_(1).jpg', alt: 'Healthy cooking activity at school', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/IMG_7211_(1).jpg', alt: 'Wellness program cooking class', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/IMG_7212_(1).jpg', alt: 'Students learning about nutrition', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/IMG_7214_(1).jpg', alt: 'Nutrition education at PSMS 108', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/IMG_7216_(1).jpg', alt: 'Students cooking during wellness class', tag: 'Wellness' },
    { src: '/assets/images/gallery/Wellness/IMG_7251_(1).jpg', alt: 'Wellness program healthy eating activity', tag: 'Wellness' },
    // BioBus
    { src: '/assets/images/gallery/BioBus/Bio_Bus.jpg', alt: 'Students exploring the BioBus mobile science lab', tag: 'BioBus' },
    { src: '/assets/images/gallery/BioBus/BioBus_2.jpg', alt: 'Students doing hands-on science aboard the BioBus', tag: 'BioBus' },
    // Food Program
    { src: '/assets/images/gallery/Food Program/Spring_Rolls.jpg', alt: 'Students making spring rolls with the SNACC food program', tag: 'Food Program' },
    // Reptile Visit
    { src: '/assets/images/gallery/Reptile Visit/reptiles.jpg', alt: 'Students meeting reptiles during a classroom animal visit', tag: 'Reptile Visit' },
  ];

  const tags = ['All', 'Additional', 'BioBus', 'Field Trips', 'Food Program', 'Halloween', 'Knicks', 'Reptile Visit', 'Wellness'];

  const filteredImages = activeTag === 'All'
    ? images
    : images.filter(image => image.tag === activeTag);

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <>
      <Navbar />
      <main id="main-content" className="bg-white">

      {/* Hero Section */}
      <section className="section-padding band-light text-brand-text-primary pt-24 md:pt-32 relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 border-2 border-brand-yellow rounded-full"></div>
          <div className="absolute bottom-10 right-10 w-40 h-40 border-2 border-brand-navy rounded-full"></div>
          <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-brand-yellow/20 rounded-full"></div>
        </div>

        <div className="content-container relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="relative mb-8">
              <span className="inline-block bg-white shadow-sm text-brand-text-primary px-6 py-3 text-sm font-medium tracking-wider border border-brand-yellow/50">
                Our Community
              </span>
            </div>
            <h1 className="text-display font-display mb-8 relative">
              <span className="relative">
                Gallery
                <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-brand-navy via-brand-yellow to-brand-navy"></div>
              </span>
            </h1>
            <p className="text-xl leading-relaxed max-w-3xl mx-auto">
              Explore moments from our vibrant school community, events, and student activities
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Grid Section */}
      <section className="section-padding bg-white">
        <div className="content-container">
          <div className="max-w-7xl mx-auto">
            {/* Tag Filter Buttons */}
            <div className="flex flex-wrap gap-3 justify-center mb-12">
              {tags.map((tag) => (
                <button
                  key={tag}
                  onClick={() => setActiveTag(tag)}
                  aria-pressed={activeTag === tag}
                  className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${
                    activeTag === tag
                      ? 'bg-brand-navy text-white shadow-lg border-2 border-brand-yellow'
                      : 'bg-gray-100 text-gray-700 hover:bg-brand-yellow/20 hover:border-brand-navy/20 border-2 border-transparent'
                  }`}
                >
                  {tag}
                </button>
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {filteredImages.map((image, index) => (
                <div
                  key={index}
                  className="group relative overflow-hidden rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer aspect-square"
                  onClick={() => openLightbox(image)}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
          onClick={closeLightbox}
          role="dialog"
          aria-modal="true"
          aria-label="Image lightbox"
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors p-2 bg-black/50 rounded-full"
            onClick={closeLightbox}
            aria-label="Close gallery lightbox"
          >
            <XMarkIcon className="w-8 h-8" />
          </button>
          <img
            src={selectedImage.src}
            alt={selectedImage.alt}
            className="max-w-full max-h-[90vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      </main>
      <Footer />
    </>
  );
};

export default Gallery;
